<template>
<section class="page">
	
</section>
</template>

<script>
export default {
	data() {
		return {};
	},
	created() {},
	methods: {},
	watch: {},
	components: {}
};
</script>
<style lang="scss" scoped>
</style>
